import { LoadablePaint } from '@confluence/loadable';

export const HubRendererLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-hub-renderer" */ './hub-renderer/HubRenderer.tsx'))
			.HubRendererComponent,
});
